module.exports = __webpack_public_path__ + "img/pv-image03.0302b74f.webp";